import React from "react"
import {FieldEditableProps} from "../../../../proto/render/editable";
import {FieldViewSize} from "../../../../const";

// const debug = "FieldPopover_EditableProto"
const debug = false

type State = {
    isHovered   : boolean
    showPopover : boolean
}

type Props = FieldEditableProps & {

    renderValue     : func
    renderValueHovered   : func
}

export default class FieldPopover_EditableProto extends React.Component<Props, State> {

    constructor(props:Props) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    onMouseEnter = () => {

        if (!this.props.field.canEdit(this.props.model) || this.props.disabled) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return //

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    onClick = () => {
        if (!this.props.field.canEdit(this.props.model)) return

        this.setState({
            showPopover     : !this.state.showPopover
        })

    }

    get classes():string {
        const classes = Classes("ui5-field-editable", this.props.className, {
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
        return classes
    }

    onValueChange(value:any, hidePopover:boolean=true) {

        hidePopover && this.hidePopover()

        this.props.onChange && this.props.onChange(value)
    }

    onDeleteClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()

        this.onValueChange(null)
    }

    onOptionClick = (option:Option) => {
        this.onValueChange(option.value)
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    renderHovered() {

        const field     = this.props.field
        const classes   = Classes(this.classes, "is-hovered")
        const hasValue  = !!(this.props.field.getViewValue(this.props.model))

        return (
            <React.Fragment>
                <div className={classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={this.onClick}>
                    {this.props.renderValueHovered(this.props.field, this.props.model)}

                    <div className="buttons flex-no-shrink">
                        {hasValue && <div className="btn-reset" onClick={this.onDeleteClick}/>}
                        <div className="btn-arrow"/>
                    </div>
                </div>
                {this.state.showPopover &&
                    <field.components.PopoverMenu {...this.props} parent={this} />
                }
            </React.Fragment>
        )
    }

    // renderValue(width: number) {
    //
    //     // @ts-ignore
    //     const option : Option = this.props.field._getOption(this.props.model.priority)
    //
    //     if (this.props.iconOnly) {
    //         return (
    //             <div className={Classes("flex-row-center-center", "w-100-percent", "txt-truncate")}>
    //                 <PriorityIcon className="" priority={option.value}/>
    //             </div>
    //         )
    //     }
    //
    //
    //     return (
    //         <div className={Classes("flex-row-left-center", "w-100-percent", "txt-truncate")}>
    //             <PriorityIcon className="fl-no-shrink m-r-5" priority={option.value}/>
    //             <div className="max-w-100-percent txt-truncate cursor-default">{option.label}</div>
    //         </div>
    //     )
    // }

    renderNotHovered() {

        return (
            <React.Fragment>
                <div className={this.classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>

                    {this.props.renderValue(this.props.field, this.props.model)}

                </div>
            </React.Fragment>
        )

    }

    render() {

        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered)
            return this.renderHovered()
        else
            return this.renderNotHovered()

    }

}



